import React from "react";

export default function UserGuideTilePostsIcon({ size = 47 }) {
  const gid = React.useId().replace(/:/g, "");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id={gid}
          x1="0"
          y1="0"
          x2="47"
          y2="47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8E2FF" />
          <stop offset="1" stopColor="#5B19C6" />
        </linearGradient>
      </defs>
      <rect width="46.75" height="46.75" rx="23.375" fill={`url(#${gid})`} />
      <path
        d="M30.375 32.375H16.375C15.825 32.375 15.3543 32.1793 14.963 31.788C14.5717 31.3967 14.3757 30.9257 14.375 30.375V16.375C14.375 15.825 14.571 15.3543 14.963 14.963C15.355 14.5717 15.8257 14.3757 16.375 14.375H30.375C30.925 14.375 31.396 14.571 31.788 14.963C32.18 15.355 32.3757 15.8257 32.375 16.375V30.375C32.375 30.925 32.1793 31.396 31.788 31.788C31.3967 32.18 30.9257 32.3757 30.375 32.375ZM17.375 25.375H29.375V23.375H17.375V25.375ZM17.375 28.375H29.375V26.875H17.375V28.375Z"
        fill="white"
      />
    </svg>
  );
}
